/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * EnrolmentInformationContainer
 *
 * @file EnrolmentInformationContainer.jsx
 * @author Anuja Gaikwad
 * @since 1.5.0
 */


import React from 'react';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';
import { InternationalSupport } from '@aquila/core';
import ContainerShell from './ContainerShell';
import ErrorBoundary from '../components/common/ErrorBoundary';
import msgObject from '../../translations';
import EnrolmentInformation from '../components/common/EnrolmentInformation';

const EnrolmentInformationContainer = (props) => {
  const intlObj = new InternationalSupport(msgObject, props.locale);

  return (
    <ContainerShell>
      <IntlProvider locale={intlObj.getLocale()} messages={intlObj.getMessages()}>
        <ErrorBoundary>
          <EnrolmentInformation {...props} />
        </ErrorBoundary>
      </IntlProvider>
    </ContainerShell>
  );
};

EnrolmentInformationContainer.propTypes = {
  locale: PropTypes.string
};

EnrolmentInformationContainer.defaultProps = {
  locale: 'en'
};

export default EnrolmentInformationContainer;

